import { searchBookingAsyncResponse } from "./types";
import * as bookingActions from "./actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_BOOKING, retrieveToken } from "../../../helpers/api";

export function* searchBookings(action: ReturnType<typeof bookingActions.searchBookingAsync.request>) {
  try {
    const page = action.payload.page ? action.payload.page : 1;
    const startTime = action.payload.startTime ? action.payload.startTime : '';
    const endTime = action.payload.endTime ? action.payload.endTime : '';
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_BOOKING.SEARCH_BOOKING(startTime, endTime), token);
    if (result.status === 200) {
      const parsed: searchBookingAsyncResponse = yield call(result.json.bind(result));
      yield put(bookingActions.searchBookingAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(bookingActions.searchBookingAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(bookingActions.searchBookingAsync.failure(parsed));
  }
}

export default function* bookingsSagaSearchBooking() {
  yield takeEvery(bookingActions.searchBookingAsync.request, searchBookings);
}
